import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivationEnd, Router } from '@angular/router';
import { Observable, of, throwError } from 'rxjs';
import { concatMap, delay, retryWhen, takeUntil } from 'rxjs/operators';
import { HttpCancelService } from 'src/app/services/httpcancel.service';

// Retain request context for network events and HTTP errors with no body.
export const httpErrorDiagnostics = new WeakMap<object, {
  requestUrl: string;
  requestMethod: string;
  status: number;
  statusText: string;
}>();

@Injectable()
export class ManageHttpInterceptor implements HttpInterceptor {
  constructor() { }
  // constructor(router: Router, private httpCancelService: HttpCancelService) {
  //   router.events.subscribe(event => {
  //     if (event instanceof ActivationEnd)
  //       this.httpCancelService.cancelPendingRequests();
  //   });
  // }
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    var res = next.handle(req).pipe(
      retryWhen(errors =>
        errors.pipe(
          concatMap((error, count) => {
            if (count < 3 && req.method === 'GET' && error.status === 504) {
              return of(error);
            }
            // A null/undefined body cannot carry diagnostics; retain its HTTP wrapper.
            const reportedError = error instanceof HttpErrorResponse && error.error == null ? error : error.error;
            if (reportedError instanceof HttpErrorResponse || reportedError?.constructor?.name === 'ProgressEvent') {
              httpErrorDiagnostics.set(reportedError, {
                requestUrl: req.urlWithParams,
                requestMethod: req.method,
                status: error.status,
                statusText: error.statusText
              });
            }
            return throwError(() => reportedError);
          }),
          delay(500)
        )
      )
    );

    return res;
    // if (req.headers.has('x-kp-alive')) return res;
    // return res.pipe(takeUntil(this.httpCancelService.onCancelPendingRequests()))
  }
}
